"use client";

import { Text } from "@hubble/web";

export function HeroDisplay({
  children,
  className,
  size = "sm"
}: {
  children: React.ReactNode;
  className?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
}) {
  return (
    <Text.Display className={className} color="white" marketing size={size}>
      {children}
    </Text.Display>
  );
}

export function HeroHeading({
  children,
  className,
  size = "xxs"
}: {
  children: React.ReactNode;
  className?: string;
  size?: "xxs" | "xs" | "sm" | "md" | "lg" | "xl";
}) {
  return (
    <Text.Heading className={className} color="white" marketing size={size}>
      {children}
    </Text.Heading>
  );
}

export function HeroBody({
  children,
  className,
  size = "xs"
}: {
  children: React.ReactNode;
  className?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
}) {
  return (
    <Text.Body className={className} color="white" marketing size={size}>
      {children}
    </Text.Body>
  );
}
